import {
  COPPEL_DESTINOS_ADQUISICION,
  COPPEL_PORTAL_BASE,
  COPPEL_PORTAL_WORKFLOWS,
} from './constants'

export function esDestinoCoppelAdquisicion(destinoId) {
  return COPPEL_DESTINOS_ADQUISICION.includes(parseInt(destinoId, 10))
}

/** URL portal Kredi con autologin SOC según destino del caso (adquisición vs mejora). */
export function urlPortalKrediCoppel(destinoId) {
  const workflow = esDestinoCoppelAdquisicion(destinoId)
    ? COPPEL_PORTAL_WORKFLOWS.adquisicion
    : COPPEL_PORTAL_WORKFLOWS.mejora
  return `${COPPEL_PORTAL_BASE}?autologin=soc&workflow=${workflow}`
}
